import Image from "../../features/Image";
import images from "../images";
import Link from "../../features/Link";
import i18next from "i18next";

class Place {
    constructor(id="", name="", image="", description="") {
        this.id = id;
        this.name = name;
        this.image = image;
        this.description = description;
        this.defaultLinks = [];
        this.beforeEntering = [];
    };

    addDefaultLink(linkName="", to="", goTo=null, conditionCallBack=null, style={}) {
        this.defaultLinks.push({linkName, to, goTo, conditionCallBack, style});
    };

    addBeforeEnteringCallback(conditionCallBack, passage) {
        this.beforeEntering.push({conditionCallBack, passage})
    };

    getImage() {
        return <Image src={images.places[this.id][this.image]}/>
    };

    getName() {
        return this.name
    };

    getLinks() {
        return (
            <div>
                {this.defaultLinks.map((val, key) => {
                    if ((val.conditionCallBack && val.conditionCallBack()) || !val.conditionCallBack) {
                        return (
                            <div key={key}>
                                <Link to={val.to} callback={val.goTo} style={val.style}>
                                    {typeof val.linkName === "string" ? i18next.t(val.linkName) : val.linkName}
                                </Link>
                            </div>
                        )
                    }
                })}
            </div>
        );
    };

    getDescription() {
        return this.description;
    }

    getCaption() {
        return <h1>{this.name}</h1>;
    };
}

export default Place;